import { render, staticRenderFns } from "./slidercontrol.vue?vue&type=template&id=38893949&"
import script from "./slidercontrol.vue?vue&type=script&lang=js&"
export * from "./slidercontrol.vue?vue&type=script&lang=js&"
import style0 from "./slidercontrol.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports